import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer/')({
    staticData: {
        modules: ['document-analyzer'],
        permissions: ['document_analyzer:use'],
    },
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/tools/document-analyzer/upload', params, replace: true });
    },
});
